export default "__VITE_ASSET__DNK5ysDH__"